(function ($) {
  // smooth-scroll / toggle modal on click of id href
  $(document).on("click", "#exportEventsButton", function (e) {
    $("#exportEventsModal").modal("toggle");
    return;
  });

  $(document).on("click", "#exportEventsModal .close", function (e) {
    $(".message-export").removeClass("show-message");
    $("#exportEventsModal").modal("toggle");
    return;
  });

  $(document).on("click", "#submitBtn", function (e) {
    $(".message-export").addClass("show-message");
    $("#exportEventsForm").submit();
  });
})(jQuery);
